import React, { useState, useEffect } from 'react'
import { Card, Typography, Descriptions, Button, Input, message } from 'antd'
import { BookOutlined, EditOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons'
import { backend } from '../../api'
import api from '../../api'

const { Title, Paragraph } = Typography

export default function AboutSoftware() {
  const [tutorial, setTutorial] = useState('')
  const [editing, setEditing] = useState(false)
  const [editContent, setEditContent] = useState('')
  const [saving, setSaving] = useState(false)
  const [appConfig, setAppConfig] = useState({ appName: '', appLogo: '' })
  const raw = sessionStorage.getItem('auth_user')
  const user = raw ? JSON.parse(raw) : {}
  const isAdmin = user?.role === 'admin'

  useEffect(() => {
    backend.getSoftwareTutorial().then(res => {
      if (res?.success) setTutorial(res.tutorial || '')
    }).catch(() => {})
    api.getAppConfig().then(cfg => {
      if (cfg) setAppConfig({ appName: cfg.appName || '', appLogo: cfg.appLogo || '' })
    })
  }, [])

  const startEdit = () => {
    setEditContent(tutorial)
    setEditing(true)
  }

  const cancelEdit = () => {
    setEditing(false)
    setEditContent('')
  }

  const saveTutorial = async () => {
    setSaving(true)
    try {
      const res = await backend.adminUpdateTutorial(editContent)
      if (res.success) {
        setTutorial(editContent)
        setEditing(false)
        message.success('教程已保存')
      } else {
        message.error(res.message || '保存失败')
      }
    } catch (e) { message.error('保存失败') }
    finally { setSaving(false) }
  }

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Title level={4} style={{ textAlign: 'center', marginBottom: 24 }}>关于软件</Title>
        <Descriptions bordered column={1} size="middle" style={{ maxWidth: 500, margin: '0 auto' }}>
          <Descriptions.Item label="软件名称">{appConfig.appName || '新媒体运营之家·矩阵'}</Descriptions.Item>
          <Descriptions.Item label="版本号">v2.0.0</Descriptions.Item>
          <Descriptions.Item label="描述">多平台账号矩阵管理系统</Descriptions.Item>
          <Descriptions.Item label="版权">
            <Paragraph style={{ marginBottom: 0 }}>Copyright 2026 {appConfig.appName || '新媒体运营之家·矩阵'}</Paragraph>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span><BookOutlined /> 软件使用教程</span>
          {isAdmin && !editing && (
            <Button type="link" icon={<EditOutlined />} onClick={startEdit}>编辑教程</Button>
          )}
        </div>
      }>
        {editing ? (
          <div>
            <Input.TextArea
              value={editContent}
              onChange={e => setEditContent(e.target.value)}
              rows={12}
              placeholder="请输入软件使用教程内容，支持纯文本..."
            />
            <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <Button icon={<CloseOutlined />} onClick={cancelEdit}>取消</Button>
              <Button type="primary" icon={<SaveOutlined />} onClick={saveTutorial} loading={saving}>保存</Button>
            </div>
          </div>
        ) : tutorial ? (
          <Paragraph style={{ whiteSpace: 'pre-wrap', marginBottom: 0 }}>
            {tutorial}
          </Paragraph>
        ) : (
          <Paragraph type="secondary">
            暂无教程内容。管理员可在设置中编辑添加。
          </Paragraph>
        )}
      </Card>
    </div>
  )
}
